import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFormOptions, FormlyFieldConfig } from '@ngx-formly/core';
import { Params, Router, ActivatedRoute } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { MasterService, FileItem } from 'src/app/services/master.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { MatTableDataSource } from '@angular/material/table';
import { Entities, SecurityLevel, VEntities } from '../../../model/structures';
import { faShieldHalved, faPen, faEnvelope, faPhone, faShield, faBoxArchive } from '@fortawesome/free-solid-svg-icons';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ImageUploadComponent } from '../modal/image-upload/image-upload.component';
import { ImageFullSizeComponent } from '../modal/image-full-size/image-full-size.component';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-edit-entity',
  templateUrl: './edit-entity.component.html',
  styleUrls: ['./edit-entity.component.css']
})
export class EditEntityComponent implements OnInit, AfterViewInit {
  public img_path: string = "";
  public faShieldHalved = faShieldHalved;
  public faPen = faPen;
  public faEnvelope = faEnvelope;
  public faPhone = faPhone;
  public faShield = faShield;
  public faBoxArchive = faBoxArchive;

  public ID: any;
  public parent_id: any;
  displayedColumns: string[] = ['ID', 'ShortTitle', 'Description', 'ArchiveSign', 'SecurityLevel'];
  selected_template = <Entities>{};
  public Entity!: Entities;
  public security_data!: SecurityLevel[];
  public security_level_selected: any;

  // Флаг режима только для просмотра
  public isReadOnly: boolean = false;
  // NEW: Флаг для режима предпросмотра шаблона
  public isTemplatePreview: boolean = false;
  // NEW: Флаг для режима создания
  public isCreateMode: boolean = false;

  public submit(): void {
    if (this.form.valid) {
      console.log("Header form data:", JSON.stringify(this.model_header));
    }
    if (this.form_body.valid) {
      console.log("Body form data:", JSON.stringify(this.model_body));
    }
  }

  // NEW: удалить выбранное главное изображение (локально)
  removeMainImage(): void {
    if (this.isReadOnly) return;
    this.img_path = '';
    if (this.model_header?.header) {
      delete this.model_header.header.imageFile;
    }
    // Также очистим input, если доступен
    try { this.mainImageInput.nativeElement.value = ''; } catch {}
  }

  // Форма редактирования (header)
  form = new FormGroup({});
  model_header: any = {};
  options: FormlyFormOptions = {};
  fields: FormlyFieldConfig[] = [];
  template: any;
  public template_private_content: any;
  public template_open_content: any;

  // NEW: данные для режима создания
  public template_list: VEntities[] = [];
  public DataSourceTable: any;
  public show_archieved: boolean = false;
  // Простой стейт для пошаговой навигации (без строгих валидаторов)
  firstFormGroup = this._formBuilder.group({ selected_template: [''] });
  secondFormGroup = this._formBuilder.group({ secondCtrl: [''] });

  // Форма для "Знаний" (body)
  form_body = new FormGroup({});
  model_body: any = {};
  options_body: FormlyFormOptions = {};
  fields_body: FormlyFieldConfig[] = [];
  tmp_header: any;
  tmp_body: any;
  header: any;
  body: any;

  // Управление прикреплёнными файлами
  files: FileItem[] = [];
  displayedFileColumns: string[] = ['ShortTitle', 'Actions'];
  dataSourceFiles = new MatTableDataSource<FileItem>(this.files);
  selectedFile: File | null = null;
  shortTitle: string = '';
  selectedFileName: string = '';
  isUploading: boolean = false;

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('mainImageInput') mainImageInput!: ElementRef<HTMLInputElement>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private service: MasterService,
    private storageService: AuthenticationService,
    private _formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private http: HttpClient,
    private _snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.ID = params['ID'];
      this.parent_id = params['parent_id'];

      // 1) проверяем матричные параметры (params)
      if (params['readonly'] === 'true' || params['readonly'] === true || params['readonly'] === '1') {
        this.isReadOnly = true;
      }
      // NEW: Проверяем, является ли это предпросмотром шаблона
      if (params['template_preview'] === 'true' || params['template_preview'] === true) {
        this.isTemplatePreview = true;
        this.isReadOnly = true; // Предпросмотр всегда в режиме readonly
      }

      // NEW: Определяем режим создания (нет ID, есть parent_id)
      this.isCreateMode = !this.ID && !!this.parent_id && !this.isTemplatePreview;

      // 2) проверяем query params на всякий случай
      const qp = this.route.snapshot.queryParamMap;
      if (!this.isReadOnly && qp.has('readonly') && (qp.get('readonly') === 'true' || qp.get('readonly') === '1')) {
        this.isReadOnly = true;
      }

      // 3) fallback: если использовался storageService.SetRouterUrl(...)
      try {
        const raw = this.storageService.GetRouterUrl ? this.storageService.GetRouterUrl() : null;
        if (raw) {
          const parsed = JSON.parse(raw);
          if (parsed && parsed.readonly) this.isReadOnly = true;
          // NEW: Проверка для предпросмотра шаблона из storage
          if (parsed && parsed.template_preview) {
            this.isTemplatePreview = true;
            this.isReadOnly = true;
          }
        }
      } catch (e) { /* ignore */ }

      if (this.isCreateMode) {
        // Инициализация сущности по умолчанию
        this.Entity = {
          ID: 0,
          EntityStructure: Number(this.parent_id) || 0,
          ShortTitle: '',
          Description: '',
          OpenContent: '',
          PrivateContent: '',
          ArchiveSign: false,
          SecurityLevel: 0,
          SecurityID: 0,
          TemplateSign: false,
          Template: 0,
          URLPicture: ''
        } as any;
        this.GetTemplateList();
      }

      this.load_root_template();
    });
  }

  // NEW: Загрузка списка шаблонов для режима создания
  public GetTemplateList() {
    this.service.GetTemplateList(this.parent_id, false).subscribe((result: any) => {
      if (result.data != null) {
        this.storageService.saveToken(result.jwt);
        const list = this.show_archieved ? result.data : result.data.filter((w: any) => w.ArchiveSign === false);
        this.template_list = list as VEntities[];
        this.DataSourceTable = new MatTableDataSource<VEntities>(this.template_list);
      } else {
        console.log('Error loading template list');
      }
    });
  }

  // NEW: Загрузка выбранного шаблона в режиме создания
  public LoadSelectedTemplate() {
    if (!this.selected_template || !this.selected_template.ID) return;
    this.service.GetTemplate(this.selected_template.ID).subscribe((result: any) => {
      if (result.data != null) {
        const _top_level = this.security_data.filter((w: any) => w.ID == result.data[0].SecurityLevel)[0].Level;
        this.security_data = this.security_data.filter((w: any) => w.Level <= _top_level);
        this.security_level_selected = this.security_data[0];
        this.storageService.saveToken(result.jwt);
        this.template_private_content = JSON.parse(result.data[0].PrivateContent || '{}');
        this.template_open_content = JSON.parse(result.data[0].OpenContent || '{}');

        // Ensure it's an object, not a string (handle double-encoded JSON in DB)
        if (typeof this.template_open_content === 'string') {
          try {
            this.template_open_content = JSON.parse(this.template_open_content);
          } catch (e) {
            console.error('Failed to parse open_content as JSON:', e);
            this.template_open_content = {};
          }
        }
        if (typeof this.template_private_content === 'string') {
          try {
            this.template_private_content = JSON.parse(this.template_private_content);
          } catch (e) {
            console.error('Failed to parse private_content as JSON:', e);
            this.template_private_content = {};
          }
        }

        this.template[0].fieldGroup[0].fieldGroup[2].props.options = [];
        for (let i = 0; i < this.security_data.length; i++) {
          const _row = { label: this.security_data[i].ShortTitle, value: this.security_data[i].Level.toString() };
          this.template[0].fieldGroup[0].fieldGroup[2].props.options.push(_row);
        }

        this.tmp_header = structuredClone(this.template);
        this.tmp_header[1] = [];
        this.tmp_body = structuredClone(this.template);
        this.tmp_body[0] = [];

        // Для open_content: интегрируем fieldGroup из parsed content
        if (this.template_open_content && typeof this.template_open_content === 'object' && Array.isArray(this.template_open_content.fieldGroup)) {
          console.log('Integrating open_content fields into tmp_body');
          this.template_open_content.fieldGroup.forEach((fgItem: any) => {
            if (fgItem && typeof fgItem === 'object') {
              this.tmp_body[1].fieldGroup[0].fieldGroup[0].fieldGroup.push(fgItem);
            }
          });
        } else {
          console.warn('open_content is not a valid Formly config with fieldGroup:', this.template_open_content);
          this.tmp_body[1].fieldGroup[0].fieldGroup[0].fieldGroup.push({ type: 'textarea', props: { label: 'Open Content', value: JSON.stringify(this.template_open_content, null, 2) } });
        }

        // Аналогично для private_content
        if (this.template_private_content && typeof this.template_private_content === 'object' && Array.isArray(this.template_private_content.fieldGroup)) {
          console.log('Integrating private_content fields into tmp_body');
          this.template_private_content.fieldGroup.forEach((fgItem: any) => {
            if (fgItem && typeof fgItem === 'object') {
              this.tmp_body[1].fieldGroup[0].fieldGroup[1].fieldGroup.push(fgItem);
            }
          });
        } else {
          console.warn('private_content is not a valid Formly config with fieldGroup:', this.template_private_content);
          this.tmp_body[1].fieldGroup[0].fieldGroup[1].fieldGroup.push({ type: 'textarea', props: { label: 'Private Content', value: JSON.stringify(this.template_private_content, null, 2) } });
        }

        this.header = {
          header: {
            ID: '',
            ShortTitle: '',
            Description: '',
            SecurityLevel: this.security_data.filter((w: any) => w.ID == result.data[0].SecurityLevel)[0].Level.toString()
          },
          tabs_root: { tabs: { open_content: {}, private_content: {} } }
        };

        // Прогружаем SQL-данные в select, если требуется
        this.loadSqlData(this.tmp_header, 'type');

        this.selected_template = result.data[0];  // Обновляем selected_template свежими данными из базы
        this.loadTemplateImage();
        this.loadTemplateFiles();

        this.model_header = structuredClone(this.header);
        this.fields = structuredClone(this.tmp_header);
        this.model_body = structuredClone(this.header);
        this.fields_body = structuredClone(this.tmp_body);
      } else {
        console.log('Error loading selected template');
      }
    });
  }

  // NEW: выбор строки шаблона из таблицы
  public getrow(row: any) {
    this.selected_template = row;
    this.LoadSelectedTemplate();
    try {
      this.firstFormGroup.setValue({ selected_template: this.selected_template.ShortTitle });
    } catch {}
  }

  // NEW: Загрузка изображения шаблона
  private loadTemplateImage() {
    if (this.selected_template && this.selected_template.URLPicture && this.selected_template.URLPicture !== 'undefined') {
      this.service.downloadMainImage(this.selected_template.URLPicture).subscribe(
        (rdn: any) => {
          this.img_path = 'data:' + rdn.mimeType + ';base64,' + rdn.data;
        },
        err => {
          console.log('Error loading template image: ' + err);
          this.img_path = '';
        }
      );
    } else {
      this.img_path = '';
    }
  }

  // NEW: Загрузка файлов шаблона
  private loadTemplateFiles() {
    if (this.selected_template && this.selected_template.ID) {
      this.service.getFiles(this.selected_template.ID.toString()).subscribe(
        response => {
          this.files = response.data || [];
          this.dataSourceFiles.data = this.files;
          this.dataSourceFiles.paginator = this.paginator;
          this.storageService.saveToken(response.jwt);
        },
        error => {
          console.error('Error fetching template files:', error);
          this.files = [];
          this.dataSourceFiles.data = this.files;
        }
      );
    } else {
      this.files = [];
      this.dataSourceFiles.data = this.files;
    }
  }

  ngAfterViewInit() {
    this.dataSourceFiles.paginator = this.paginator;
  }

  public load_root_template() {
    this.http.get<any>(`/assets/root_template.json`).subscribe(JsonSchema => {
      this.template = JsonSchema;
      this.service.GetSecurityList().subscribe((result: any) => {
        this.security_data = result.data;
        if (this.isTemplatePreview) {
          this.LoadTemplateForPreview();
        } else if (this.isCreateMode) {
          // В режиме создания ждём выбора шаблона, ничего не грузим дополнительно
          return;
        } else {
          this.LoadSelectedEntity();
        }
      });
    });
  }

  // NEW: Метод для загрузки шаблона в режиме предпросмотра
  public LoadTemplateForPreview() {
    // В режиме предпросмотра this.ID - это ID шаблона
    this.service.GetTemplate(this.ID).subscribe((result: any) => {
      if (result.data?.[0]) {
        this.storageService.saveToken(result.jwt);
        this.selected_template = result.data[0];

        const _top_level = this.security_data.find((w: any) => w.ID == this.selected_template.SecurityLevel)?.Level ?? Infinity;
        this.security_data = this.security_data.filter((w: any) => w.Level <= _top_level);
        this.security_level_selected = this.security_data[0];

        this.template_private_content = JSON.parse(this.selected_template.PrivateContent || '{}');
        this.template_open_content = JSON.parse(this.selected_template.OpenContent || '{}');

        this.template[0].fieldGroup[0].fieldGroup[2].props.options = this.security_data.map(s => ({ label: s.ShortTitle, value: s.Level.toString() }));

        this.tmp_header = structuredClone(this.template);
        this.tmp_header[1] = [];
        this.tmp_body = structuredClone(this.template);
        this.tmp_body[0] = [];
        // NEW: Перед добавлением в fieldGroup, убедимся, что это объекты
        if (typeof this.template_open_content === 'string') {
          try {
            this.template_open_content = JSON.parse(this.template_open_content);
          } catch (e) {
            console.error('Failed to parse open_content as JSON:', e);
            this.template_open_content = {};
          }
        }
        if (typeof this.template_private_content === 'string') {
          try {
            this.template_private_content = JSON.parse(this.template_private_content);
          } catch (e) {
            console.error('Failed to parse private_content as JSON:', e);
            this.template_private_content = {};
          }
        }

        // Для open_content: интегрируем fieldGroup из parsed content
        if (this.template_open_content && typeof this.template_open_content === 'object' && Array.isArray(this.template_open_content.fieldGroup)) {
          console.log('Integrating open_content fields into tmp_body');
          this.template_open_content.fieldGroup.forEach((fgItem: any) => {
            if (fgItem && typeof fgItem === 'object') {
              this.tmp_body[1].fieldGroup[0].fieldGroup[0].fieldGroup.push(fgItem);
            }
          });
        } else {
          console.warn('open_content is not a valid Formly config with fieldGroup:', this.template_open_content);
          // Fallback: push пустой объект или пропустить
          this.tmp_body[1].fieldGroup[0].fieldGroup[0].fieldGroup.push({ type: 'textarea', props: { label: 'Open Content', value: JSON.stringify(this.template_open_content, null, 2) } });
        }

        // Аналогично для private_content
        if (this.template_private_content && typeof this.template_private_content === 'object' && Array.isArray(this.template_private_content.fieldGroup)) {
          console.log('Integrating private_content fields into tmp_body');
          this.template_private_content.fieldGroup.forEach((fgItem: any) => {
            if (fgItem && typeof fgItem === 'object') {
              this.tmp_body[1].fieldGroup[0].fieldGroup[1].fieldGroup.push(fgItem);
            }
          });
        } else {
          console.warn('private_content is not a valid Formly config with fieldGroup:', this.template_private_content);
          this.tmp_body[1].fieldGroup[0].fieldGroup[1].fieldGroup.push({ type: 'textarea', props: { label: 'Private Content', value: JSON.stringify(this.template_private_content, null, 2) } });
        }

        this.header = {
          header: {
            ID: "",
            ShortTitle: "",
            Description: "",
            SecurityLevel: this.security_data.find((w: any) => w.ID == this.selected_template.SecurityLevel)?.Level.toString()
          },
          tabs_root: { tabs: { open_content: {}, private_content: {} } }
        };

        this.model_header = structuredClone(this.header);
        this.fields = structuredClone(this.tmp_header);
        this.model_body = structuredClone(this.header);
        this.fields_body = structuredClone(this.tmp_body);

        this.disableAllFields(this.fields);
        this.disableAllFields(this.fields_body);

        // Загружаем изображение и файлы для предварительного просмотра
        // В режиме превью сущности изображение не загружаем, оставляем пустым
        // this.loadTemplateImageForPreview();
        this.img_path = '';
        this.loadTemplateFilesForPreview();

      } else {
        this._snackBar.open('Не удалось загрузить шаблон для предпросмотра', '', { duration: 3000, panelClass: ['red-snackbar'] });
      }
    });
  }

  // NEW: Загрузка изображения шаблона для предварительного просмотра
  private loadTemplateImageForPreview() {
    if (this.selected_template && this.selected_template.URLPicture && this.selected_template.URLPicture !== 'undefined') {
      this.service.downloadMainImage(this.selected_template.URLPicture).subscribe(
        (rdn: any) => {
          this.img_path = 'data:' + rdn.mimeType + ';base64,' + rdn.data;
        },
        err => {
          console.log('Error loading template image for preview: ' + err);
          this.img_path = '';
        }
      );
    } else {
      this.img_path = '';
    }
  }

  // NEW: Загрузка файлов шаблона для предварительного просмотра
  private loadTemplateFilesForPreview() {
    if (this.selected_template && this.selected_template.ID) {
      this.service.getFiles(this.selected_template.ID.toString()).subscribe(
        response => {
          this.files = response.data || [];
          this.dataSourceFiles.data = this.files;
          this.dataSourceFiles.paginator = this.paginator;
          this.storageService.saveToken(response.jwt);
        },
        error => {
          console.error('Error fetching template files for preview:', error);
          this.files = [];
          this.dataSourceFiles.data = this.files;
        }
      );
    } else {
      this.files = [];
      this.dataSourceFiles.data = this.files;
    }
  }

  public LoadSelectedEntity() {
    this.service.GetTemplate(this.ID).subscribe((result: any) => {
      if (result.data != null) {
        this.storageService.saveToken(result.jwt);
        this.Entity = result.data[0];
        this.service.GetTemplate(this.Entity.Template).subscribe((result: any) => {
          if (result.data != null) {
            const _top_level = this.security_data.filter((w: any) => w.ID == result.data[0].SecurityLevel)[0].Level;
            this.security_data = this.security_data.filter((w: any) => w.Level <= _top_level);
            this.security_level_selected = this.security_data[0];
            this.selected_template = result.data[0];
            this.template_private_content = JSON.parse(result.data[0].PrivateContent);
            this.template_open_content = JSON.parse(result.data[0].OpenContent);
            this.template[0].fieldGroup[0].fieldGroup[2].props.options = [];
            for (let i = 0; i < this.security_data.length; i++) {
              const _row = { label: this.security_data[i].ShortTitle, value: this.security_data[i].Level.toString() };
              this.template[0].fieldGroup[0].fieldGroup[2].props.options.push(_row);
            }
            this.tmp_header = structuredClone(this.template);
            this.tmp_header[1] = [];
            this.tmp_body = structuredClone(this.template);
            this.tmp_body[0] = [];
            this.tmp_body[1].fieldGroup[0].fieldGroup[0].fieldGroup.push(this.template_open_content);
            this.tmp_body[1].fieldGroup[0].fieldGroup[1].fieldGroup.push(this.template_private_content);

            if (this.Entity.URLPicture && this.Entity.URLPicture !== 'undefined' && !this.isReadOnly) {
              this.service.downloadMainImage(this.Entity.URLPicture).subscribe((rdn: any) => {
                this.img_path = 'data:' + rdn.mimeType + ';base64,' + rdn.data;
              },
              err0 => {
                console.log('Error loading main image: ' + err0);
              });
            } else if (this.isReadOnly) {
              // В режиме readonly не показываем изображение
              this.img_path = '';
            }

            let _open: any = {};
            let _private: any = {};
            if (this.Entity.OpenContent && this.Entity.OpenContent !== 'undefined') {
              try {
                _open = typeof this.Entity.OpenContent === 'string' ? JSON.parse(this.Entity.OpenContent) : this.Entity.OpenContent;
              } catch (e) {
                console.error('Failed to parse Entity.OpenContent:', e);
                _open = {};
              }
            }
            if (this.Entity.PrivateContent && this.Entity.PrivateContent !== 'undefined') {
              try {
                _private = typeof this.Entity.PrivateContent === 'string' ? JSON.parse(this.Entity.PrivateContent) : this.Entity.PrivateContent;
              } catch (e) {
                console.error('Failed to parse Entity.PrivateContent:', e);
                _private = {};
              }
            }
            this.header = {
              header: {
                ID: this.Entity.ID,
                ShortTitle: this.Entity.ShortTitle,
                Description: this.Entity.Description,
                SecurityLevel: this.security_data.filter((w: any) => w.ID == this.selected_template.SecurityLevel)[0].Level.toString()
              },
              tabs_root: {
                tabs: {
                  open_content: _open,
                  private_content: _private
                }
              }
            };

            this.model_header = structuredClone(this.header);
            this.fields = structuredClone(this.tmp_header);
            this.model_body = structuredClone(this.header);
            this.fields_body = structuredClone(this.tmp_body);

            // Если режим только для просмотра — отключаем все поля
            if (this.isReadOnly) {
              this.disableAllFields(this.fields);
              this.disableAllFields(this.fields_body);
            }

            // Если режим только для просмотра — отключаем формы и очищаем все поля
            if (this.isReadOnly) {
              try { this.form.disable(); } catch (e) { console.warn('form.disable failed', e); }
              try { this.form_body.disable(); } catch (e) { console.warn('form_body.disable failed', e); }

              // Отключаем все поля в readonly режиме
              this.options = { ...this.options };
              this.options_body = { ...this.options_body };

              // Очищаем все поля в режиме readonly
              this.model_header = {
                header: {
                  ID: '',
                  ShortTitle: '',
                  Description: '',
                  SecurityLevel: ''
                },
                tabs_root: {
                  tabs: {
                    open_content: {},
                    private_content: {}
                  }
                }
              };

              // Очищаем поля файлов
              if (this.model_header && this.model_header.header) {
                delete this.model_header.header.imageFile;
                delete this.model_header.header.file;
              }

              // Очищаем model_body для readonly режима
              this.model_body = {
                header: {
                  ID: '',
                  ShortTitle: '',
                  Description: '',
                  SecurityLevel: ''
                },
                tabs_root: {
                  tabs: {
                    open_content: {},
                    private_content: {}
                  }
                }
              };
            }

            if (!this.isReadOnly) {
              this.fetchFiles();
            } else {
              // В режиме readonly файлы не загружаем
              this.files = [];
              this.dataSourceFiles.data = this.files;
            }
          }
        });
      } else {
        console.log('Error loading entity');
      }
    });
  }

  loadSqlData = (obj: any, key: any) => {
    let newObj: any = {};
    for (const ogKey in obj) {
      if (ogKey === key) {
        let _select_db: string = '';
        if (obj[key] === 'select' && obj['props'] && obj['props']['options']) {
          obj['props']['options'].forEach((element: any) => {
            if (element['select_db'] != undefined) {
              _select_db = element['select_db'];
              this.service.CustomRequest(_select_db).subscribe((result: any) => {
                obj['props']['options'] = [];
                for (let i = 0; i < result.data.length; i++) {
                  obj['props']['options'].push(result.data[i]);
                }
                this.model_header = structuredClone(this.header);
                this.fields = structuredClone(this.tmp_header);
                this.model_body = structuredClone(this.header);
                this.fields_body = structuredClone(this.tmp_body);

                // Если режим только для просмотра — отключаем все поля
                if (this.isReadOnly) {
                  this.disableAllFields(this.fields);
                  this.disableAllFields(this.fields_body);
                }
              });
            }
          });
        }
      } else if (typeof obj[ogKey] === 'object') {
        newObj[ogKey] = this.loadSqlData(obj[ogKey], key);
      } else {
        newObj[ogKey] = obj[ogKey];
      }
    }
    return newObj;
  }

  onMainImageSelected(event: any): void {
    if (this.isReadOnly) return;
    const file: File = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.img_path = e.target.result;
        if (!this.model_header.header) {
          this.model_header.header = {};
        }
        this.model_header.header.imageFile = event.target.files;
      };
      reader.onerror = (error) => {
        console.error('Ошибка при чтении файла:', error);
      };
      reader.readAsDataURL(file);
    }
  }

  save() {
    if (this.isReadOnly) {
      this._snackBar.open('Режим только для просмотра — сохранение отключено', '', { duration: 2000, panelClass: ['yellow-snackbar'] });
      return;
    }
    if (this.isCreateMode) {
      this.saveCreate();
      return;
    }
    if (this.model_header.header.imageFile != undefined) {
      this.service.uploadMainImage(this.Entity.ID.toString(), this.model_header.header.imageFile[0]).subscribe(
        (rup: any) => {
          delete this.model_header.header.imageFile;
          this.save_func(rup.data);
        },
        err0 => {
          console.log('Error uploading main image: ' + err0);
        }
      );
    } else {
      this.save_func(null);
    }
  }

  save_func(_url_picture: string | null) {
    this.Entity.ShortTitle = this.model_header.header.ShortTitle;
    this.Entity.Description = this.model_header.header.Description;
    this.Entity.SecurityLevel = this.security_data.filter((w: SecurityLevel) => w.Level == this.model_header.header.SecurityLevel)[0].ID!;
    this.Entity.OpenContent = this.model_body.tabs_root.tabs.open_content;
    this.Entity.PrivateContent = this.model_body.tabs_root.tabs.private_content;
    if (_url_picture) {
      this.Entity.URLPicture = _url_picture;
    }

    this.service.UpdateOntologyEntity(this.Entity, "Entity").subscribe((result: any) => {
      if (result.res == 'success') {
        this._snackBar.open('Entity successfully updated', '', {
          duration: 1000,
          panelClass: ['blue-snackbar']
        });
        this.fetchFiles();
      } else {
        this._snackBar.open('Server error', '', {
          duration: 1000,
          panelClass: ['red-snackbar']
        });
      }
    }, err0 => {
      console.log('Error updating entity: ' + err0.message);
    });
  }

  // NEW: сохранение при создании
  private saveCreate() {
    if (!this.selected_template || !this.selected_template.ID) {
      this._snackBar.open('Не выбран шаблон', '', { duration: 2000, panelClass: ['yellow-snackbar'] });
      return;
    }

    // Заполняем сущность из форм
    this.Entity.ShortTitle = this.model_header?.header?.ShortTitle || '';
    this.Entity.Description = this.model_header?.header?.Description || '';
    this.Entity.Template = this.selected_template.ID;
    this.Entity.SecurityLevel = this.security_data.filter((w: SecurityLevel) => w.Level == this.model_header.header.SecurityLevel)[0].ID!;

    if (this.model_body?.tabs_root?.tabs?.open_content != undefined) {
      this.Entity.OpenContent = this.model_body.tabs_root.tabs.open_content;
    } else {
      this.Entity.OpenContent = JSON.stringify({});
    }
    if (this.model_body?.tabs_root?.tabs?.private_content != undefined) {
      this.Entity.PrivateContent = this.model_body.tabs_root.tabs.private_content;
    } else {
      this.Entity.PrivateContent = JSON.stringify({});
    }

    // Сначала создаём сущность, затем при необходимости загрузим главное изображение
    this.service.CreateOntology(this.Entity, 'Entity').subscribe((result: any) => {
      if (result.res === 'success') {
        // Обновляем ID созданной сущности, если пришёл
        if (result.data && result.data.ID) {
          this.Entity.ID = result.data.ID;
        }
        this._snackBar.open('Сущность успешно добавлена', '', { duration: 1000, panelClass: ['blue-snackbar'] });

        if (this.model_header.header?.imageFile && this.Entity.ID) {
          this.service.uploadMainImage(this.Entity.ID.toString(), this.model_header.header.imageFile[0]).subscribe(
            (rup: any) => {
              delete this.model_header.header.imageFile;
              this._snackBar.open('Изображение загружено', '', { duration: 1500, panelClass: ['blue-snackbar'] });
            },
            err0 => {
              console.log('Error uploading main image: ' + err0);
              this._snackBar.open('Создано, но ошибка при загрузке изображения', '', { duration: 2000, panelClass: ['yellow-snackbar'] });
            }
          );
        }

        // После создания можно переключиться в режим редактирования текущей сущности
        this.isCreateMode = false;
        // Перезагрузим данные сущности для форм
        this.ID = this.Entity.ID;
        this.LoadSelectedEntity();
      } else {
        this._snackBar.open('Ошибка сервера', '', { duration: 1000, panelClass: ['red-snackbar'] });
      }
    }, err0 => {
      console.log('Error creating entity: ' + err0);
    });
  }

  exit() {
    window.top!.close();
  }

  show_full() {
    const dialogRef = this.dialog.open(ImageFullSizeComponent, {
      data: this.img_path,
    });
    dialogRef.afterClosed().subscribe(() => {
      console.log('Dialog closed');
    }, err => {
      console.log('Error: ' + err);
    });
  }

  fetchFiles(): void {
    if (!this.Entity.ID) return;
    this.service.getFiles(this.Entity.ID.toString()).subscribe(
      response => {
        this.files = response.data;
        this.dataSourceFiles.data = this.files;
        this.dataSourceFiles.paginator = this.paginator;
        this.storageService.saveToken(response.jwt);
      },
      error => {
        console.error('Error fetching files:', error);
        this._snackBar.open('Failed to load files', '', {
          duration: 3000,
          panelClass: ['red-snackbar']
        });
      }
    );
  }

  onFileSelected(event: any): void {
    if (this.isReadOnly) return;
    const file: File = event.target.files[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        this._snackBar.open('File is too large. Maximum size is 10 MB.', '', {
          duration: 3000,
          panelClass: ['red-snackbar']
        });
        return;
      }
      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'text/plain'];
      if (!allowedTypes.includes(file.type)) {
        this._snackBar.open('Invalid file type.', '', {
          duration: 3000,
          panelClass: ['red-snackbar']
        });
        return;
      }
      this.selectedFile = file;
      this.selectedFileName = file.name;
      this.shortTitle = this.shortTitle || file.name;
    }
  }

  uploadFile(): void {
    if (this.isReadOnly) return;
    if (this.selectedFile && this.shortTitle) {
      this.isUploading = true;
      this.service.addFile(this.Entity.ID.toString(), this.selectedFile, this.shortTitle).subscribe(
        response => {
          this.isUploading = false;
          if (response.res === 'success') {
            this._snackBar.open('File uploaded successfully', '', {
              duration: 2000,
              panelClass: ['blue-snackbar']
            });
            this.fetchFiles();
            this.selectedFile = null;
            this.selectedFileName = '';
            this.shortTitle = '';
            this.fileInput.nativeElement.value = '';
          } else {
            this._snackBar.open('Error uploading file: ' + response.res, '', {
              duration: 3000,
              panelClass: ['red-snackbar']
            });
          }
        },
        error => {
          this.isUploading = false;
          console.error('Error uploading file:', error);
          this._snackBar.open('Failed to upload file', '', {
            duration: 3000,
            panelClass: ['red-snackbar']
          });
        }
      );
    } else {
      this._snackBar.open('Please select a file and enter a display name', '', {
        duration: 3000,
        panelClass: ['yellow-snackbar']
      });
    }
  }

  deleteFile(fileId: string): void {
    if (this.isReadOnly) return;
    if (confirm('Are you sure you want to delete this file?')) {
      this.service.deleteFile(fileId).subscribe(
        response => {
          if (response.res === 'success') {
            this._snackBar.open('File deleted successfully', '', {
              duration: 2000,
              panelClass: ['blue-snackbar']
            });
            this.fetchFiles();
          } else {
            this._snackBar.open('Error deleting file: ' + response.res, '', {
              duration: 3000,
              panelClass: ['red-snackbar']
            });
          }
        },
        error => {
          console.error('Error deleting file:', error);
          this._snackBar.open('Failed to delete file', '', {
            duration: 3000,
            panelClass: ['red-snackbar']
          });
        }
      );
    }
  }

  downloadFile(fileId: string, shortTitle: string, url: string): void {
    this.service.downloadFile(fileId).subscribe(
      blob => {
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        const extension = this.getFileExtension(url);
        let filename = shortTitle;
        if (!shortTitle.endsWith(extension)) {
          filename += extension;
        }
        a.download = filename;
        a.click();
        URL.revokeObjectURL(objectUrl);
        this._snackBar.open('File downloaded successfully', '', {
          duration: 2000,
          panelClass: ['blue-snackbar']
        });
      },
      error => {
        console.error('Error downloading file:', error);
        this._snackBar.open('Failed to download file', '', {
          duration: 3000,
          panelClass: ['red-snackbar']
        });
      }
    );
  }

   getFileExtension(url: string): string {
     const index = url.lastIndexOf('.');
     return index !== -1 ? url.substring(index) : '';
   }


   private disableAllFields(fields: any[]): void {
     if (!Array.isArray(fields)) {
       console.warn('disableAllFields: fields is not an array', fields);
       return;
     }

     fields.forEach((field: any, index: number) => {
       if (typeof field === 'string') {
         console.warn(`disableAllFields: field at index ${index} is a string (JSON?):`, field.substring(0, 100) + '...');
         // Попытка парсинга, если это JSON fields
         try {
           const parsed = JSON.parse(field);
           if (typeof parsed === 'object' && parsed.key) {
             // Это Formly field config как JSON — парсим и отключаем
             parsed.props = { ... (parsed.props || {}), disabled: true };
             fields[index] = parsed;  // Заменяем строку на объект
             console.log('Parsed and disabled JSON field:', parsed.key);
           } else {
             console.warn('String is not a valid Formly field JSON:', parsed);
           }
         } catch (e) {
           console.error('Failed to parse string field as JSON:', e, field);
         }
         return;  // Пропускаем дальнейшую обработку
       }

       if (typeof field !== 'object' || field === null) {
         console.warn('disableAllFields: field is not an object', field);
         return;
       }

       // Рекурсивно отключаем вложенные поля
       if (Array.isArray(field.fieldGroup)) {
         this.disableAllFields(field.fieldGroup);
       } else if (field.fieldGroup && typeof field.fieldGroup === 'object') {
         for (const key in field.fieldGroup) {
           if (Object.prototype.hasOwnProperty.call(field.fieldGroup, key)) {
             this.disableAllFields([field.fieldGroup[key]]);
           }
         }
       }
     });
   }
}
